export const prescriptionTypeValue = {
    "first": "first",
    "nextOne": "nextOne",
    "final": "final",
    "moment": "moment",
    "other": "other"
}


export const prescriptionTypeLabel = {
    [prescriptionTypeValue.first]: 'prescription.template.prescriptionType.first',
    [prescriptionTypeValue.nextOne]: 'prescription.template.prescriptionType.nextOne',
    [prescriptionTypeValue.final]: 'prescription.template.prescriptionType.final',
    [prescriptionTypeValue.moment]: 'prescription.template.prescriptionType.moment',
    [prescriptionTypeValue.other]: 'prescription.template.prescriptionType.other'
}


